<template>
  <a
    class="m-the-modal-shadow"
    @click.prevent="$modal.closeModal"
  >
  </a>
</template>

<script>
export default {
  name: 'MoleculeTheModalShadow'
}
</script>
